const modelNames = [
  'gateRecords',
  'leaveRecords',
  'leaveQtys',
  'attendanceRecords',
  'overtimeRecords',
  'comments',
  'dates',
  'users',
]

const models = { }
modelNames.forEach(name => {
  models[name] = require(`./${name}.js`)
})

module.exports = models



// WEBPACK FOOTER //
// ./src/models/index.js